const situacaoMunicipioEscolaEnum = {
  semAtuacao: 0,
  atua: 1,
};

export default situacaoMunicipioEscolaEnum;
